'use es6';

import ImmutableModel from 'DesignData/models/ImmutableModel';
export default class ContextMenuItemGroup extends ImmutableModel {
  constructor(props) {
    return super(props);
  }

}
ContextMenuItemGroup.REQUIRED_FIELDS = ['options'];